import Goal from 'routes/Goal/components/Goal';

export default Goal;
